(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atopia-bottles-remaining"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const renderDigits = (container, display) => {
      const value = String(display || '—');
      container.innerHTML = '';
      container.style.setProperty('--digit-count', Math.max(value.length, 1));

      Array.from(value).forEach((character) => {
        const cell = document.createElement('span');
        cell.textContent = character;
        container.appendChild(cell);
      });
    };

    const initInventorySection = (scope = document) => {
      scope.querySelectorAll('[data-atopia-inventory]').forEach((root) => {
        if (root.dataset.inventoryReady === 'true') return;
        root.dataset.inventoryReady = 'true';

        const select = root.querySelector('[data-atopia-inventory-select]');
        const status = root.querySelector('[data-atopia-inventory-status]');
        const statusText = status?.querySelector('b');
        const digits = root.querySelector('[data-atopia-inventory-digits]');
        const caption = root.querySelector('[data-atopia-inventory-caption]');
        const buyButton = root.querySelector('[data-atopia-inventory-buy]');
        const buyButtonText = buyButton?.querySelector('span');

        if (!select || !status || !statusText || !digits || !caption || !buyButton || !buyButtonText) return;

        const updateVariant = () => {
          const option = select.options[select.selectedIndex];
          const available = option.dataset.available === 'true';
          const management = option.dataset.management;
          const policy = option.dataset.policy;
          const quantity = Math.max(Number.parseInt(option.dataset.quantity || '0', 10), 0);
          const requiresSellingPlan = option.dataset.requiresSellingPlan === 'true';
          const threshold = Number.parseInt(root.dataset.lowStockThreshold || '0', 10);
          const trackedFinite = management && policy === 'deny';

          let state = 'available';
          let display = '—';
          let statusLabel = root.dataset.availableText;
          let captionLabel = root.dataset.availableCaption;
          let enabled = available;

          if (!available) {
            state = 'sold-out';
            display = root.dataset.soldOutDisplay || '—';
            statusLabel = root.dataset.soldOutText;
            captionLabel = root.dataset.soldOutCaption;
            enabled = false;
          } else if (requiresSellingPlan) {
            state = 'selling-plan';
            display = '—';
            statusLabel = root.dataset.sellingPlanText;
            captionLabel = root.dataset.sellingPlanCaption;
            enabled = false;
          } else if (trackedFinite) {
            state = quantity <= threshold ? 'low-stock' : 'in-stock';
            display = String(quantity);
            statusLabel = state === 'low-stock' ? root.dataset.lowStockText : root.dataset.inStockText;
            captionLabel = root.dataset.remainingCaption;
          }

          status.dataset.state = state;
          statusText.textContent = statusLabel;
          caption.textContent = captionLabel;
          digits.classList.toggle('atopia-inventory__digits--message', !trackedFinite || !available);
          digits.setAttribute('aria-label', trackedFinite && available ? `${quantity} ${captionLabel}` : captionLabel);
          renderDigits(digits, display);

          if (buyButton.tagName === 'A') {
            buyButton.href = enabled ? `${root.dataset.cartBase}/${option.value}:1` : '#';
            buyButton.classList.toggle('is-disabled', !enabled);
            buyButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
            buyButtonText.textContent = enabled
              ? root.dataset.buyButtonText
              : state === 'sold-out'
                ? root.dataset.soldOutButtonText
                : root.dataset.sellingPlanButtonText;
            if (enabled) buyButton.removeAttribute('tabindex');
            else buyButton.setAttribute('tabindex', '-1');
          }
        };

        buyButton.addEventListener('click', (event) => {
          if (buyButton.getAttribute('aria-disabled') === 'true') event.preventDefault();
        });
        select.addEventListener('change', updateVariant);
        updateVariant();
      });
    };

    initInventorySection();
    document.addEventListener('shopify:section:load', (event) => initInventorySection(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atopia-in-the-bottle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBottleSection = (scope = document) => {
      scope.querySelectorAll('[data-atopia-bottle]').forEach((root) => {
        if (root.dataset.bottleReady === 'true') return;
        root.dataset.bottleReady = 'true';

        const allowMultiple = root.dataset.allowMultiple === 'true';
        const details = Array.from(root.querySelectorAll('[data-atopia-bottle-detail]'));

        details.forEach((detail) => {
          detail.addEventListener('toggle', () => {
            if (!detail.open || allowMultiple) return;
            details.forEach((other) => {
              if (other !== detail) other.open = false;
            });
          });
        });
      });
    };

    initBottleSection();

    document.addEventListener('shopify:section:load', (event) => initBottleSection(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const detail = event.target.matches('[data-atopia-bottle-detail]')
        ? event.target
        : event.target.closest('[data-atopia-bottle-detail]');
      if (detail) detail.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atopia-taste"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activateTab = (root, tab, moveFocus = false) => {
      if (!root || !tab) return;

      root.querySelectorAll('[data-atopia-taste-tab]').forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });

      root.querySelectorAll('[data-atopia-taste-panel]').forEach((panel) => {
        panel.hidden = panel.id !== tab.dataset.panelId;
      });

      if (moveFocus) tab.focus();
    };

    const initTaste = (scope = document) => {
      scope.querySelectorAll('[data-atopia-taste]').forEach((root) => {
        if (root.dataset.tasteReady === 'true') return;
        root.dataset.tasteReady = 'true';

        const tabs = Array.from(root.querySelectorAll('[data-atopia-taste-tab]'));

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activateTab(root, tab));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();

            let nextIndex = index;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;

            activateTab(root, tabs[nextIndex], true);
          });
        });
      });
    };

    initTaste();

    document.addEventListener('shopify:section:load', (event) => initTaste(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const tab = event.target.matches('[data-atopia-taste-tab]')
        ? event.target
        : event.target.querySelector('[data-atopia-taste-tab]');
      if (!tab) return;
      activateTab(tab.closest('[data-atopia-taste]'), tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
